import { render, staticRenderFns } from "./k2Switch.vue?vue&type=template&id=f9d8d85c"
import script from "./k2Switch.vue?vue&type=script&lang=js"
export * from "./k2Switch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports